import React from 'react'
import { useForm } from 'react-hook-form'
import { RadioGroup } from '../common/form'
import { Typography, makeStyles, Button, Grid } from '@material-ui/core'
import { yupResolver } from '@hookform/resolvers'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { RootState, setRequestFormPayload } from 'src/lib/store'
import { RequestInfo } from 'src/lib/types'
import { RELATIONSHIP_TYPES, ACCOUNT_TYPES, REQUEST_TYPES, ON_BEHALF_OPTIONS } from 'src/lib/constants'
import { genRequestFormValidationSchema, genRequestFormDefaultValues, isEmpty } from 'src/lib/helpers'

export const RequestInfoForm: React.FC = () => {
  const payloadState = useSelector((state: RootState) => state.payload.data)
  const classes = useStyles()
  const history = useHistory()
  const dispatch = useDispatch()

  const validationSchema = genRequestFormValidationSchema()

  const { control, errors, watch, handleSubmit } = useForm<RequestInfo>({
    resolver: yupResolver(validationSchema),
    defaultValues: genRequestFormDefaultValues(payloadState)
  })

  const watchFields = watch()
  const requestTypes = REQUEST_TYPES

  const onSubmit = (payload: RequestInfo) => {
    dispatch(setRequestFormPayload(payload))
    const route = watchFields.onBehalf === 'Yes' ? 'agent-info' : 'consumer-info'
    history.push(`/${route}`)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="mb-5">
      <Typography variant="h3" gutterBottom className="pt-4">
        What is your relationship with SAFE?
      </Typography>
      <RadioGroup className="pl-0" name="relationshipType" ariaLabel="What is your relationship with SAFE?" control={control} items={RELATIONSHIP_TYPES} error={errors.relationshipType} testId="relationship" />

      {watchFields.relationshipType === 'Current or former member/applicant for SAFE products or services' && (
        <>
          <Typography variant="h3" gutterBottom className="pt-4">
            What type of product or service do/did you have at SAFE? <br /> Or what type of product or service did you apply for?
          </Typography>
          <RadioGroup className="pl-0" name="accountType" ariaLabel="What type of product or service do/did you have at SAFE? Or what type of product or service did you apply for?" control={control} items={ACCOUNT_TYPES} error={errors.accountType} />
        </>
      )}
      {!isEmpty(watchFields.relationshipType) && (
        <>
          <Typography variant="h3" gutterBottom className="pt-4">
            What are you asking for today? Here are your options.
          </Typography>
          <RadioGroup className="pl-0" name="requestType" ariaLabel="What are you asking for today? Here are your options." control={control} items={requestTypes} error={errors.requestType} />

          <Typography variant="h3" gutterBottom className="pt-4">
            Are you making this request as the authorized agent of another person?
          </Typography>
          <RadioGroup className="pl-0" name="onBehalf" ariaLabel="Are you making this request as the authorized agent of another person?" control={control} items={ON_BEHALF_OPTIONS} error={errors.onBehalf} />

          <Grid container>
            <Grid item xs={1} sm={2} md={3} />
            <Grid item xs={10} sm={8} md={6}>
              <Button variant="contained" color="primary" className={classes.submitButton} type="submit">
                Next
              </Button>
            </Grid>
            <Grid item xs={1} sm={2} md={3} />
          </Grid>
        </>
      )}
    </form>
  )
}

const useStyles = makeStyles({
  buttonContainer: { display: 'flex', justifyContent: 'center', marginTop: 40, marginBottom: 20 },
  submitButton: { margin: '40px 0px 20px 0px', width: '100%' }
})
